export const BETSLIP_MODES = {
	SINGLE: 1,
	MULTI: 2
}

export const DISABLED_BETSLIP_MODES = [];

export const BETSLIP_STAKE_MODES = {
	PER_BET: 0,
	SPLIT: 1
}

export const BET_STATE = {
	PENDING: 1,
	RETURN: 2,
	WON: 4,
	SEMIWON: 8,
	SEMILOST: 16,
	LOST: 32,
	CANCELLED: 64,
	REJECTED_BY_OPERATOR: 128
}

export const ODD_STATE = {
	PENDING: 0,
	WON: 1,
	LOST: 2,
	SEMIWON: 3,
	RETURN: 4,
	SEMILOST: 5
}

export const MULTI_MODE_BETS_MAX_FACTORS = {
	WITH_KENO_BET: 11001,
	WITHOUT_KENO_BET: 1001
};

export const BETSLIP_BETS_LIMIT = 30;

export const BETSLIP_KEEP_FOCUSED_STAKE_DATA_ATTRS = {
	BET_STAKE: "data-is-bet-stake",
	BETSLIP_STAKE: "data-is-betslip-stake",
	FAV_BET_ITEM: "data-is-fav-bet-item",
	KEYBOARD: "data-is-keyboard"
}

export const QUICK_BET_ANIMATABLE_EL_DATA_ATTRS = {
	BET_HISTORY: "history",
	BETSLIP_HEADER: "betslip-header",
	BETSLIP: "betslip"
}
